export default "__VITE_ASSET__BWKyN6aj__"